export const PAGE_SIZE_OPTIONS = ['5', '10', '25', '50'];
